export const LANG_RESOURCES = {
    "zh-CHS": {
        "startCondition": "启动条件",
        "yes": "是",
        "no": "否",
        "confirm": "确定",
        "edit": "编辑",
        "moveUp": "上移",
        "moveDown": "下移",
        "add": "新增",
        "remove": "删除",
        "isEnabled": "是否启用",
        "type": "类型",
        "commonComponent": "通用构件",
        "expression": "表达式",
        "billAction": "业务动作",
        "content": "内容",
        "description": "描述",
        "operation": "操作",
        "typeMustNotBeNull": "类型不可为空",
        "contentMustNotBeNull": "内容不可为空",
        "commonComponentMetadataSelector": "通用构件选择",
        "pleaseSelectOneItemAtLeast": "请至少选择一条数据",
        "pleaseEndCurrentRowEditing": "请先结束当前行编辑",
    },
    "en": {
        "startCondition": "Start Condition",
        "yes": "Yes",
        "no": "No",
        "confirm": "Confirm",
        "edit": "Edit",
        "moveUp": "Move Up",
        "moveDown": "Move Down",
        "add": "Add",
        "remove": "Remove",
        "isEnabled": "Is Enabled",
        "type": "Type",
        "commonComponent": "Common Component",
        "expression": "Expression",
        "billAction": "Bill Action",
        "content": "Content",
        "description": "Description",
        "operation": "Operation",
        "typeMustNotBeNull": "Type must not be null",
        "contentMustNotBeNull": "Content must not be null",
        "commonComponentMetadataSelector": "Common Component Selector",
        "pleaseSelectOneItemAtLeast": "Please select one item at least",
        "pleaseEndCurrentRowEditing": "Please end current row editing",
    },
    "zh-CHT": {
        "startCondition": "啓動條件",
        "yes": "是",
        "no": "否",
        "confirm": "確定",
        "edit": "編輯",
        "moveUp": "上移",
        "moveDown": "下移",
        "add": "新增",
        "remove": "刪除",
        "isEnabled": "是否啓用",
        "type": "類型",
        "commonComponent": "通用構件",
        "expression": "表達式",
        "billAction": "業務動作",
        "content": "內容",
        "description": "描述",
        "operation": "操作",
        "typeMustNotBeNull": "類型不可爲空",
        "contentMustNotBeNull": "內容不可爲空",
        "commonComponentMetadataSelector": "通用構件選擇",
        "pleaseSelectOneItemAtLeast": "請至少選擇壹條數據",
        "pleaseEndCurrentRowEditing": "請先結束當前行編輯",
    }
};